import { useRef } from "react";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  MeasuringStrategy,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { BoardScrollContext } from "./BoardContext";
import type { BoardProps } from "./types";

const measuring = {
  droppable: {
    strategy: MeasuringStrategy.BeforeDragging,
  },
};

export function Board({
  children,
  onDragStart,
  onDragOver,
  onDragEnd,
}: BoardProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: { distance: 5 },
  });
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: { distance: 8 },
  });
  const keyboardSensor = useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates,
  });
  const sensors = useSensors(mouseSensor, touchSensor, keyboardSensor);

  return (
    <BoardScrollContext.Provider value={{ scrollRef, wrapperRef }}>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        measuring={measuring}
        onDragStart={onDragStart}
        onDragOver={onDragOver}
        onDragEnd={onDragEnd}
      >
        <div ref={wrapperRef} className="relative flex-1 min-h-0 h-full">
          <div ref={scrollRef} className="flex gap-5 overflow-x-auto h-full">
            {children}
          </div>
        </div>
      </DndContext>
    </BoardScrollContext.Provider>
  );
}
